import { PayloadAction, createSlice } from "@reduxjs/toolkit";

/**
 * NG-7512: availability of Google reCaptcha.
 * - "loading": detection in flight, or not started yet
 * - "available": grecaptcha resolved successfully
 * - "unavailable": the reCaptcha script failed to load, or detection timed out
 *
 * Drives the fail-open fallback on the public registration forms: when reCaptcha is
 * unavailable the widget is hidden and the token is dropped from the submit gate so users
 * are not hard-blocked. reCaptcha is FE-only today (the token is never verified by the BE),
 * so failing open carries no server-enforced security regression.
 */
export type TRecaptchaStatus = "loading" | "available" | "unavailable";

export type TRecaptchaStatusState = {
    status: TRecaptchaStatus;
};

const initialState: TRecaptchaStatusState = {
    status: "loading",
};

const recaptchaStatusSlice = createSlice({
    initialState,
    name: "recaptchaStatusReducer",
    reducers: {
        setRecaptchaStatus(state: TRecaptchaStatusState, action: PayloadAction<TRecaptchaStatus>) {
            return { ...state, status: action.payload };
        },
    },
});

export const { setRecaptchaStatus } = recaptchaStatusSlice.actions;

export default recaptchaStatusSlice.reducer;
